module.exports = __webpack_public_path__ + "img/logo.b34cc1d9.png";